import { render, staticRenderFns } from "./DwEnrollmentsTermsOverview.vue?vue&type=template&id=2c13b92a&"
import script from "./DwEnrollmentsTermsOverview.vue?vue&type=script&lang=js&"
export * from "./DwEnrollmentsTermsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports